import { useInfiniteQuery } from 'react-query'

import { OptimizationProcesses } from '../../../types'
import { Filtering } from '../../../types/filtering'
import { Sorting } from '../../../types/sorting'
import { get } from '../../../utils/api'
import { getOffsetFromUrl, getQueryString } from '../../../utils/queryString'
import { serializeSorting } from '../../../utils/sorting'

export const useOptimizationProcesses = ({
  sorting,
  filtering,
}: {
  sorting: Sorting
  filtering: Filtering
}) => {
  const limit = 20

  const {
    data: response,
    isLoading,
    hasNextPage,
    fetchNextPage,
  } = useInfiniteQuery(
    ['optimization-processes', sorting, filtering],
    ({ pageParam }) =>
      get<OptimizationProcesses>(
        `/optimization-processes/?${getQueryString({
          offset: pageParam,
          limit,
          ...filtering,
          ordering: serializeSorting(sorting),
        })}`
      ),
    {
      getNextPageParam: (lastPage) => getOffsetFromUrl(lastPage.next),
      retry: false,
      keepPreviousData: true,
    }
  )

  const data = response?.pages.map((p) => p.results).flat() || []
  const isEmpty = !isLoading && data.length === 0

  return {
    data,
    isLoading,
    isEmpty,
    hasNextPage,
    fetchNextPage,
  }
}
